import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

const Switch = props => {
  const [checked, setChecked] = useState(props.checked)
  const [required, setRequired] = useState(false)

  useEffect(() => {
    setChecked(props.checked)
  }, [props.checked])

  const handleChange = e => {
    if (required) {
      setRequired(false)
    }

    setChecked(e.target.checked)
    props.onChange(e)
  }

  const handleInvalid = e => {
    e.preventDefault()
    setRequired(true)
  }

  return (
    <div
      className={[midas.formGroup, required && midas.hasWarning]
        .filter(val => val)
        .join(' ')}
      data-cy={props.dataCy}
    >
      {props.label && (
        <label className={midas.formLabel} htmlFor={props.id}>
          {props.label} {props.required && <span>*</span>}
        </label>
      )}
      <label
        className={[midas.formSwitch, props.disabled && midas.disabled]
          .filter(val => val)
          .join(' ')}
      >
        <input
          id={props.id}
          type="checkbox"
          checked={!!checked}
          value={checked}
          onChange={e => handleChange(e)}
          disabled={props.disabled}
          required={props.required}
          onInvalid={e => !props.disabled && handleInvalid(e)}
            autoFocus={props.autoFocus} // eslint-disable-line
        />
        <i className={midas.formIcon} />
        {props.boldText ? (
          <strong>{props.text}</strong>
        ) : (
          <span>{props.text}</span>
        )}
        {props.children}
      </label>
      {required && <div className={midas.formInputHint}>{props.required}</div>}
    </div>
  )
}

Switch.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  text: PropTypes.string.isRequired,
  boldText: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.string,
  dataCy: PropTypes.string,
}

Switch.defaultProps = {
  children: null,
  label: null,
  boldText: false,
  checked: false,
  disabled: false,
  autoFocus: false,
  required: null,
  dataCy: null,
  onChange: () => {},
}

export default Switch
